export var TelemetryEventType;
(function (TelemetryEventType) {
    TelemetryEventType["EXAMPLE_APPLICATION_OPENED"] = "EXAMPLE_APPLICATION_OPENED";
    TelemetryEventType["PACKAGE_METADATA"] = "PACKAGE_METADATA";
    TelemetryEventType["METHOD_CALLED"] = "METHOD_CALLED";
    TelemetryEventType["COMPONENT_MOUNTED"] = "COMPONENT_MOUNTED";
})(TelemetryEventType || (TelemetryEventType = {}));
export class TelemetryEventRequest {
    constructor(data) {
        this.payload = data.payload;
        this.sdkVersion = data.sdkVersion;
        this.sdkName = data.sdkName;
        this.identifier = data.identifier;
        this.type = data.type;
    }
    toJson() {
        const map = {
            identifier: this.identifier,
            type: this.type.toString(),
        };
        if (this.payload != null) {
            map['payload'] = JSON.stringify(this.payload);
        }
        if (this.sdkVersion != null) {
            map['sdk_version'] = this.sdkVersion;
        }
        if (this.sdkName != null) {
            map['sdk'] = this.sdkName;
        }
        return map;
    }
    toJsonString() {
        return JSON.stringify(this.toJson());
    }
}
